import { useSelector } from 'react-redux'
import { Card, Badge, Button } from '../components/ui'

const DashboardPage = () => {
  const { user, tenant } = useSelector((state) => state.auth)

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-800">Dashboard</h1>
        <p className="text-gray-600 mt-1">Welcome back, {user?.name}!</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <Card title="Tenant Information">
          {tenant && (
            <div className="space-y-2 text-sm text-gray-600">
              <p><span className="font-medium">Name:</span> {tenant.name}</p>
              <p><span className="font-medium">Key:</span> {tenant.tenant_key}</p>
              <p className="flex items-center gap-2">
                <span className="font-medium">Status:</span>
                <Badge variant={tenant.is_active ? 'success' : 'danger'} size="sm">
                  {tenant.is_active ? 'Active' : 'Inactive'}
                </Badge>
              </p>
            </div>
          )}
        </Card>

        <Card title="User Information">
          {user && (
            <div className="space-y-2 text-sm text-gray-600">
              <p><span className="font-medium">Name:</span> {user.name}</p>
              <p><span className="font-medium">Email:</span> {user.email}</p>
              <p><span className="font-medium">Username:</span> {user.username}</p>
            </div>
          )}
        </Card>

        <Card title="Quick Actions">
          <div className="space-y-2">
            <Button variant="primary" size="sm" className="w-full">
              View Templates
            </Button>
            <Button variant="secondary" size="sm" className="w-full">
              Manage Assets
            </Button>
          </div>
        </Card>
      </div>
    </div>
  )
}

export default DashboardPage

